import { useTranslation } from "react-i18next";
import { Box, Button, Typography } from "@mui/material";

import { UserServicesResponse } from "../../../../../GoService/api/types/userService.types";
import { ServiceCard, ServiceCardLoader } from "../../../../../GoService/components/ServiceCard";

import EmptyServicesFigure from "../../../../assets/images/empty-services.png";

import Slider from "../Slider";
import { useNavigate } from "react-router-dom";
import { getCreateServiceRoute } from "../../../../../../routers/routeUtils";

const SERVICE_LIMIT = 5;

const ServicesList = ({
  fullName,
  entityUserId,
  isOwn,
  isDataLoading,
  servicesData,
}: {
  fullName: string;
  entityUserId?: string;
  isOwn?: boolean;
  isDataLoading?: boolean;
  servicesData?: UserServicesResponse;
}) => {
  if (!servicesData && !isDataLoading) return null;

  if ((!isDataLoading && !servicesData) || (!isDataLoading && servicesData?.items.length === 0))
    return <EmptyServices fullName={fullName} isOwn={isOwn} />;

  return (
    <Box sx={styles.root}>
      <Box sx={styles.container}>
        <Slider
          items={servicesData?.items.map((service) => <ServiceCard key={service.id} service={service} />) || []}
          isLoading={isDataLoading}
          loadingComponent={<ServiceCardLoader />}
          loadingCount={SERVICE_LIMIT}
        />
      </Box>
    </Box>
  );
};

const EmptyServices = ({ fullName, isOwn }: { fullName: string; isOwn?: boolean }) => {
  const { t } = useTranslation("profiles", { keyPrefix: "goService" });

  const navigate = useNavigate();
  const handleCreateService = () => {
    navigate(getCreateServiceRoute());
  };
  return (
    <Box sx={styles.emptyContainer}>
      <Box sx={styles.emptyImage} component="img" src={EmptyServicesFigure} alt="Empty Services" />
      <Typography sx={styles.emptyText}>
        {isOwn ? t("noOfferedServices_own") : t("noOfferedServices", { userName: fullName })}
      </Typography>
      {isOwn && (
        <Button variant="outlined-sm" onClick={handleCreateService}>
          {t("createService")}
        </Button>
      )}
    </Box>
  );
};

const styles = {
  root: {
    width: "100%",
  },
  container: {
    position: "relative" as const,
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  emptyContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: "16px",
  },
  emptyImage: {
    width: "107px",
    height: "80px",
  },
  emptyText: {
    color: "var(--Dark---800, #414141)",
    textAlign: "center",
    fontFamily: "Montserrat",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "20px",
  },
};

export default ServicesList;
